import { useQuery } from '@tanstack/react-query';

import { useStoreApi } from '../../api';
import { storeKeys } from '../../query-key-factory';
import { PostCheckoutCartResponse, ReceiptCartResponse } from './types';

const useShowPostCheckoutCart = ({
  cartId,
  email,
  enabled = true,
}: {
  cartId?: string;
  email?: string;
  enabled?: boolean;
}) => {
  const StoreApi = useStoreApi();

  const getPostCheckoutCart = async () => {
    const params = new URLSearchParams();

    params.append('email', email ?? '');
    params.append('include', 'membership_card');

    const { data } = await StoreApi.get<PostCheckoutCartResponse>(
      `/consumer/post-checkout/carts/${cartId}?${params.toString()}`
    );

    return data;
  };

  const key = cartId ? storeKeys.id('user').consumer.postCheckoutCarts.id(cartId).detail : [];

  return useQuery({
    queryKey: key,
    queryFn: getPostCheckoutCart,
    enabled: !!cartId && enabled,
  });
};

const useShowPostCheckoutCartReceipt = ({ cartId }: { cartId?: string }) => {
  const StoreApi = useStoreApi();

  const getPostCheckoutCartReceipt = async () => {
    const { data } = await StoreApi.get<ReceiptCartResponse>(
      `consumer/post-checkout/carts/${cartId}/receipt`
    );
    return data.cart;
  };

  const key = cartId ? storeKeys.id('user').consumer.postCheckoutCarts.id(cartId).receipt : [];

  return useQuery({
    queryKey: key,
    queryFn: getPostCheckoutCartReceipt,
    enabled: !!cartId,
  });
};

export { useShowPostCheckoutCart, useShowPostCheckoutCartReceipt };
